import { AuthUser, DB_COLLECTION_NAMES } from "@constants";
import { useGetDocument } from "../useGetDocument";

function useGetUser(userId: string): AuthUser | null {
  const [databaseUserObject] = useGetDocument<AuthUser>(
    DB_COLLECTION_NAMES.USERS,
    userId ? userId : "",
  );
  if (!databaseUserObject) return null;
  return databaseUserObject;
}

export { useGetUser };
export type { AuthUser };
